import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  align-items: flex-start;
`

const Input = styled.input`
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  background: transparent;
  font-size: 16px;
  height: 32px;
  width: 100%;
  padding: 12px 32px 12px 0px;

  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #b3b3b3;
  }
`

const InputUnit = styled.div`
  position: absolute;
  right: 0;
`

const Unit = styled.div`
  color: #b3b3b3;
  display: flex;
  align-items: center;
`

interface Props {
  placeholder?: string
  value?: string | number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  width?: string
  height?: string
  unit?: string
  type?: string
}

const InputOnly = (props: Props) => {
  const { placeholder, value, onChange, width, height, unit, type } = props
  const [inputValue, setInputValue] = useState<string | number>(value || '')

  useEffect(() => {
    if (type === 'number' && value !== undefined) {
      const val = value.toString()
      const [integer, decimal] = val.split('.')
      const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      setInputValue(
        decimal ? `${formattedInteger}.${decimal}` : formattedInteger
      )
    } else {
      setInputValue(value || '')
    }
  }, [value, type])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value
    if (type === 'number') {
      val = val.replace(/,/g, '') // 기존의 콤마 제거
      if (!isNaN(Number(val))) {
        const [integer, decimal] = val.split('.')
        const formattedInteger = Number(integer).toLocaleString() // 콤마 추가
        const formattedValue =
          decimal !== undefined
            ? `${formattedInteger}.${decimal}`
            : formattedInteger
        setInputValue(formattedValue)
        if (onChange) {
          const event = { ...e, target: { ...e.target, value: val } }
          onChange(event)
        }
        return
      }
    }
    setInputValue(val)
    if (onChange) {
      const event = { ...e, target: { ...e.target, value: val } }
      onChange(event)
    }
  }

  return (
    <InputWrapper>
      <Input
        style={{ width: width, height: height }}
        type="text"
        placeholder={placeholder || '이름을 입력하세요'}
        value={inputValue}
        onChange={handleChange}
      />
      {unit && (
        <InputUnit>
          <Unit>{unit}</Unit>
        </InputUnit>
      )}
    </InputWrapper>
  )
}

export default InputOnly
